export default __webpack_public_path__ + "static/media/closing-img.4390f5a0.svg";